import React from "react";

let pendingStyles;
export function ensureFullStyles() {
  if (typeof document === "undefined") return Promise.resolve();
  const link = document.querySelector("link[data-home-full-css]");
  if (link?.dataset.failed === "true") return Promise.reject(new Error("Page styles could not be loaded"));
  if (link?.dataset.fetched === "true") {
    link.media = "all";
    link.dataset.loaded = "true";
  }
  if (!link || link.dataset.loaded === "true" || (link.sheet && link.media === "all")) return Promise.resolve();
  if (pendingStyles) return pendingStyles;
  pendingStyles = new Promise((resolve, reject) => {
    let timer;
    const cleanup = () => {
      clearTimeout(timer);
      link.removeEventListener("load", ready);
      link.removeEventListener("error", failed);
    };
    const ready = () => { cleanup(); link.media = "all"; link.dataset.loaded = "true"; resolve(); };
    const failed = () => { cleanup(); reject(new Error("Page styles could not be loaded")); };
    link.addEventListener("load", ready);
    link.addEventListener("error", failed);
    timer = setTimeout(failed, 15000);
    if (link.dataset.loaded === "true" || (link.sheet && link.media === "all")) ready();
  });
  return pendingStyles;
}
function StyleLoadError() {
  return <div role="alert" style={{ padding: 24, textAlign: "center" }}>
    <p>This part of the page could not load. Please try again.</p>
    <button type="button" onClick={() => window.location.reload()} style={{ padding: "10px 18px", border: "1px solid currentColor", borderRadius: 12 }}>Reload page</button>
  </div>;
}
export function lazyWithStyles(load) {
  return React.lazy(async () => {
    // Start both downloads together, but never render a deferred control with
    // only the initial shell's Tailwind rules. Non-shell routes are a no-op.
    const module = load();
    const styles = ensureFullStyles();
    const [loaded, ready] = await Promise.all([module, styles.then(() => true, () => false)]);
    return ready ? loaded : { default: StyleLoadError };
  });
}
